import { IdentityTypeNameDecorator, BaseIdentity, Expose } from "@nts/std";

@IdentityTypeNameDecorator('SignTemplateLongOpIdentity')
export class SignTemplateLongOpIdentity extends BaseIdentity {

    private _templateId: number;

    @Expose()
    get templateId(): number {
        return this.getValue<number>(() => this._templateId, 'templateId');
    }
    set templateId(value: number) {
        this.setValue<number>(() => { this._templateId = value; }, value, 'templateId');
    }
}
